//export const API_URL = 'https://samruddhi_api_v2.latlong.in'; // production
// export const API_URL = 'https://samruddhi_v2_staging.latlong.in'; //staging
export const API_URL = 'https://shwetapatra_api.latlong.in'; // production

